var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slim-multi mb-3",class:{multi: _vm.divCount > 1}},[_c('div',{ref:"uploadFile",staticClass:"file-drop-area"})])
}
var staticRenderFns = []

export { render, staticRenderFns }